import React, { useState, useRef, useEffect } from "react";
import { createPortal } from "react-dom";
import { useNavigate } from "react-router-dom";
import { usePermission } from "../../hooks/usePermission";
import "./SearchOverlay.css";

// All sidebar page links grouped by category
const ALL_PAGES = [
  // Main Pages
  {
    name: "Dashboard",
    path: "/dashboard",
    icon: "bx bxs-dashboard",
    category: "Pages",
    permission: "dashboard-view",
  },
  {
    name: "Members",
    path: "/users",
    icon: "bx bx-user",
    category: "Pages",
    permission: "members-list",
  },
  {
    name: "Meeting Schedules",
    path: "/weekly-meetings",
    icon: "bx bx-calendar",
    category: "Pages",
    permission: "meeting-schedules-list",
  },
  // {
  //   name: "Meeting Fees",
  //   path: "/meeting-fees",
  //   icon: "bx bx-money",
  //   category: "Pages",
  //   permission: "monthly-fees-list",
  // },
  {
    name: "Monthly Fees",
    path: "/monthly-fees",
    icon: "bx bx-money",
    category: "Pages",
    permission: "monthly-fees-list",
  },
  {
    name: "RnR",
    path: "/one-to-one",
    icon: "bx bx-conversation",
    category: "Pages",
    permission: "121s-list",
  },
  {
    name: "RFLs",
    path: "/referrals",
    icon: "bx bx-share-alt",
    category: "Pages",
    permission: "referrals-list",
  },
  {
    name: "TYNs",
    path: "/tyfcbs",
    icon: "bx bx-happy-heart-eyes",
    category: "Pages",
    permission: "tyfcbs-list",
  },
  {
    name: "Events",
    path: "/events",
    icon: "bx bx-calendar-event",
    category: "Pages",
    permission: "events-list",
  },
  {
    name: "News Feed",
    path: "/news",
    icon: "bx bx-news",
    category: "Pages",
    permission: "news-list",
  },
  {
    name: "Leads",
    path: "/feed-posts",
    icon: "bx bx-file",
    category: "Pages",
    permission: "feed-posts-list",
  },
  {
    name: "Incomes",
    path: "/incomes",
    icon: "bx bx-dollar-circle",
    category: "Pages",
    permission: "incomes-list",
  },
  {
    name: "Expenses",
    path: "/expenses",
    icon: "bx bx-credit-card",
    category: "Pages",
    permission: "expenses-list",
  },
  {
    name: "Sponsors",
    path: "/sponsors",
    icon: "bx bx-donate-heart",
    category: "Pages",
    permission: "sponsors-list",
  },
  {
    name: "Testimonials",
    path: "/testimonials",
    icon: "bx bx-message-square-dots",
    category: "Pages",
    permission: "testimonials-list",
  },
  {
    name: "Roles & Permissions",
    path: "/roles",
    icon: "bx bx-lock-alt",
    category: "Pages",
    permission: "roles-list",
  },
  // {
  //   name: "Attendance QR Code",
  //   path: "/attendance-qr-code",
  //   icon: "bx bx-qr",
  //   category: "Pages",
  //   permission: "settings-list",
  // },

  // Visitors
  {
    name: "Visitors - General",
    path: "/visitors/general",
    icon: "bx bx-group",
    category: "Visitors",
    permission: "visitors-general-list",
  },
  {
    name: "Visitors - Chief Guest",
    path: "/visitors/chief-guest",
    icon: "bx bx-star",
    category: "Visitors",
    permission: "visitors-chief-guest-list",
  },
  {
    name: "Visitors - Inductions",
    path: "/visitors/inductions",
    icon: "bx bx-user-plus",
    category: "Visitors",
    permission: "visitors-inductions-list",
  },
  {
    name: "Visitors - Power Date",
    path: "/visitors/power-date",
    icon: "bx bx-calendar-star",
    category: "Visitors",
    permission: "visitors-power-date-list",
  },

  // Reports
  {
    name: "Reports - TYNs",
    path: "/reports/tyfcbs",
    icon: "bx bx-bar-chart-alt-2",
    category: "Reports",
    permission: "reports-tyns-list",
  },
  {
    name: "Reports - BIZ Given",
    path: "/reports/biz-given",
    icon: "bx bx-bar-chart-alt-2",
    category: "Reports",
    permission: "reports-biz-given-list",
  },
  {
    name: "Reports - RnR",
    path: "/reports/one-to-one",
    icon: "bx bx-bar-chart-alt-2",
    category: "Reports",
    permission: "reports-121s-list",
  },
  {
    name: "Reports - RFLs",
    path: "/reports/referrals",
    icon: "bx bx-bar-chart-alt-2",
    category: "Reports",
    permission: "reports-referrals-list",
  },
  {
    name: "Reports - Visitors",
    path: "/reports/visitors",
    icon: "bx bx-bar-chart-alt-2",
    category: "Reports",
    permission: "reports-visitors-list",
  },
  {
    name: "Reports - Visitors General",
    path: "/reports/visitors-general",
    icon: "bx bx-bar-chart-alt-2",
    category: "Reports",
    permission: "reports-visitors-general-list",
  },
  {
    name: "Reports - Chief Guest",
    path: "/reports/visitors-chief-guest",
    icon: "bx bx-bar-chart-alt-2",
    category: "Reports",
    permission: "reports-visitors-chief-guest-list",
  },
  {
    name: "Reports - Inductions",
    path: "/reports/visitors-inductions",
    icon: "bx bx-bar-chart-alt-2",
    category: "Reports",
    permission: "reports-visitors-inductions-list",
  },
  {
    name: "Reports - Power Date",
    path: "/reports/visitors-power-date",
    icon: "bx bx-bar-chart-alt-2",
    category: "Reports",
    permission: "reports-visitors-power-date-list",
  },
  {
    name: "Reports - Reward Points",
    path: "/reports/points",
    icon: "bx bx-trophy",
    category: "Reports",
    permission: "reports-reward-points",
  },
  {
    name: "Points System",
    path: "/points-system",
    icon: "bx bx-star",
    category: "Pages",
    permission: "points-system-list",
  },
  {
    name: "Reports - Chapter Pending Fee",
    path: "/reports/fees",
    icon: "bx bx-bar-chart-alt-2",
    category: "Reports",
    permission: "reports-fees-list",
  },
  {
    name: "Reports - Attendance",
    path: "/reports/attendance",
    icon: "bx bx-bar-chart-alt-2",
    category: "Reports",
    permission: "reports-attendance-list",
  },
  {
    name: "Reports - Overall",
    path: "/reports/overall",
    icon: "bx bx-bar-chart-alt-2",
    category: "Reports",
    permission: "reports-overall-list",
  },
  {
    name: "Reports - Membership Expiry & Renewals",
    path: "/reports/membership-expiry-renewals",
    icon: "bx bx-bar-chart-alt-2",
    category: "Reports",
    permission: "reports-membership-expiry-renewal-list",
  },
  {
    name: "Reports - Incomes & Expenses Ledger",
    path: "/reports/ledger",
    icon: "bx bx-bar-chart-alt-2",
    category: "Reports",
    permission: "reports-ledger-list",
  },

  // Masters
  {
    name: "Countries",
    path: "/countries",
    icon: "bx bx-globe",
    category: "Masters",
    permission: "countries-list",
  },
  {
    name: "States",
    path: "/states",
    icon: "bx bx-map",
    category: "Masters",
    permission: "states-list",
  },
  {
    name: "Regions",
    path: "/regions",
    icon: "bx bx-map-pin",
    category: "Masters",
    permission: "regions-list",
  },
  {
    name: "Chapters",
    path: "/chapters",
    icon: "bx bx-book-open",
    category: "Masters",
    permission: "chapters-list",
  },
  {
    name: "Country Admins",
    path: "/country-admin-users",
    icon: "bx bx-user-circle",
    category: "Masters",
    permission: "country-admins-list",
  },
  {
    name: "State Admins",
    path: "/state-admin-users",
    icon: "bx bx-user-circle",
    category: "Masters",
    permission: "state-admins-list",
  },
  {
    name: "Region Admins",
    path: "/region-admin-users",
    icon: "bx bx-user-circle",
    category: "Masters",
    permission: "region-admins-list",
  },
  {
    name: "Chapter Admins",
    path: "/chapter-admin-users",
    icon: "bx bx-user-circle",
    category: "Masters",
    permission: "chapter-admins-list",
  },
  {
    name: "User Roles",
    path: "/user-roles",
    icon: "bx bx-id-card",
    category: "Masters",
    permission: "user-roles-list",
  },
  {
    name: "Business Category",
    path: "/category",
    icon: "bx bx-category",
    category: "Masters",
    permission: "business-category-list",
  },
  {
    name: "Income Category",
    path: "/income-category",
    icon: "bx bx-category-alt",
    category: "Masters",
    permission: "income-category-list",
  },
  {
    name: "Expense Category",
    path: "/expense-category",
    icon: "bx bx-category-alt",
    category: "Masters",
    permission: "expense-category-list",
  },
  {
    name: "Leads Category",
    path: "/posts-category",
    icon: "bx bx-category-alt",
    category: "Masters",
    permission: "posts-category-list",
  },
  {
    name: "Sponsors Category",
    path: "/sponsors-category",
    icon: "bx bx-category-alt",
    category: "Masters",
    permission: "sponsors-category-list",
  },
  {
    name: "Blood Groups",
    path: "/blood-groups",
    icon: "bx bx-heart",
    category: "Masters",
    permission: "blood-groups-list",
  },
  // {
  //   name: "Crowns",
  //   path: "/crowns",
  //   icon: "bx bx-crown",
  //   category: "Masters",
  //   permission: "crowns-list",
  // },
  // {
  //   name: "Forum Settings",
  //   path: "/forum-settings",
  //   icon: "bx bx-cog",
  //   category: "Settings",
  //   permission: "forum-settings-list",
  // },
  {
    name: "Chapter Finance Access",
    path: "/chapter-finance-access",
    icon: "bx bx-wallet",
    category: "Masters",
    permission: "chapter-finance-access-list",
  },
];


const SearchOverlay = ({ isOpen, onClose }) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [activeIndex, setActiveIndex] = useState(0);
  const inputRef = useRef(null);
  const listRef = useRef(null);
  const navigate = useNavigate();
  const { hasPermission } = usePermission();

  // Filter pages: first by permission, then by search term
  const allowedPages = ALL_PAGES.filter((page) => hasPermission(page.permission));

  const filteredPages = searchTerm.trim()
    ? allowedPages.filter((page) =>
        page.name.toLowerCase().includes(searchTerm.toLowerCase()),
      )
    : allowedPages;

  // Group filtered pages by category
  const groupedPages = filteredPages.reduce((acc, page) => {
    if (!acc[page.category]) {
      acc[page.category] = [];
    }
    acc[page.category].push(page);
    return acc;
  }, {});

  // Flat list for keyboard navigation
  const flatList = filteredPages;

  // Focus input when overlay opens
  useEffect(() => {
    if (isOpen) {
      setSearchTerm("");
      setActiveIndex(0);
      setTimeout(() => {
        inputRef.current?.focus();
      }, 100);
    }
  }, [isOpen]);

  // Scroll active item into view
  useEffect(() => {
    const activeEl = listRef.current?.querySelector(
      ".search-result-item.active",
    );
    if (activeEl) {
      activeEl.scrollIntoView({ block: "nearest" });
    }
  }, [activeIndex]);

  const handleKeyDown = (e) => {
    if (e.key === "ArrowDown") {
      e.preventDefault();
      setActiveIndex((prev) => Math.min(prev + 1, flatList.length - 1));
    } else if (e.key === "ArrowUp") {
      e.preventDefault();
      setActiveIndex((prev) => Math.max(prev - 1, 0));
    } else if (e.key === "Enter") {
      e.preventDefault();
      if (flatList[activeIndex]) {
        handleNavigate(flatList[activeIndex].path);
      }
    } else if (e.key === "Escape") {
      onClose();
    }
  };

  const handleNavigate = (path) => {
    navigate(path);
    onClose();
  };

  if (!isOpen) return null;

  let globalIndex = 0;

  return createPortal(
    <>
      <div className="search-overlay-backdrop" onClick={onClose}></div>
      <div className="search-overlay-modal">
        {/* Search Input */}
        <div className="search-overlay-header">
          <i className="bx bx-search search-overlay-icon"></i>
          <input
            ref={inputRef}
            type="text"
            className="search-overlay-input"
            placeholder="Type a command or search..."
            value={searchTerm}
            onChange={(e) => {
              setSearchTerm(e.target.value);
              setActiveIndex(0);
            }}
            onKeyDown={handleKeyDown}
          />
          <button className="search-overlay-close" onClick={onClose}>
            <i className="bx bx-x"></i>
          </button>
        </div>

        {/* Results List */}
        <div className="search-overlay-results" ref={listRef}>
          {Object.keys(groupedPages).length === 0 ? (
            <div className="search-no-results">
              <i className="bx bx-search-alt-2"></i>
              <p>No results found for "{searchTerm}"</p>
            </div>
          ) : (
            Object.entries(groupedPages).map(([category, pages]) => (
              <div key={category} className="search-result-group">
                <div className="search-result-category">{category}</div>
                {pages.map((page) => {
                  const currentIndex = globalIndex++;
                  return (
                    <div
                      key={page.path}
                      className={`search-result-item ${currentIndex === activeIndex ? "active" : ""}`}
                      onClick={() => handleNavigate(page.path)}
                      onMouseEnter={() => setActiveIndex(currentIndex)}
                    >
                      <i className={`${page.icon} search-result-item-icon`}></i>
                      <span className="search-result-item-name">
                        {page.name}
                      </span>
                    </div>
                  );
                })}
              </div>
            ))
          )}
        </div>
      </div>
    </>,
    document.body,
  );
};

export default SearchOverlay;
